<template>
  <section>
    <header
      class="steps"
      :class="{ 'formtimeline-vertical': vertical, 'steps--icon': showIcons }"
    >
      <ul :class="'list-' + steps.length">
        <li
          v-for="(step, index) in steps"
          :key="step.name"
          style="width: auto"
          :class="{ active: index === currentStep, final: index < currentStep }"
        >
          <span
            v-if="showIcons"
            class="bullet bullet--icon"
            :class="step.type ?? 'bullet--default'"
          >
            <i :class="step.icon" />
          </span>
          <span v-else class="bullet">
            <b v-if="index === currentStep">&bull;</b>
            <template v-else>&nbsp;</template>
          </span>
          <span class="step-name">{{ step.name }}</span>
        </li>
      </ul>
    </header>
  </section>
</template>

<script>
export const FormTimelineTypes = {
  DEFAULT: 'bullet--default',
  SUCCESS: 'bullet--primary',
  SECONDARY: 'bullet--secondary'
}
export default {
  props: {
    currentStep: {
      type: Number,
      default: 0,
      required: false
    },
    steps: {
      type: Array,
      default: () => {
        return []
      }
    },
    vertical: {
      type: Boolean,
      default: false
    },
    showIcons: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';
.steps {
  background-color: var(--bg-color-primary);
  border-radius: $border-radius;

  height: auto;
  margin-top: 0.9375rem;
  // overflow: hidden;
  // position: relative;
  &.formtimeline-vertical {
    padding: 0.75rem;
    height: 100%;
    ul {
      display: flex;
      flex-direction: column;
      &:after {
        content: none;
      }
      li {
        text-align: left;
        padding-bottom: 2.5rem;
        position: relative;
        display: flex;
        align-items: baseline;
        .bullet {
          display: inline-block;
          margin: 0 0.75rem 0 0;
          min-width: 25px;
        }
        .step-name {
          display: inline-block;
          align-self: center;
        }
        &:before {
          content: '';
          height: 100%;
          // width: 0.15rem;
          display: block;
          position: absolute;
          top: 5px;
          left: 11px;

          border-left: 0.15rem solid $neutral-color-4;
          border-color: var(--neutral-color-4);
          z-index: 0;
        }
        &:not(.final):before {
          border-left-style: dashed;
        }
        &:last-child:before {
          content: none;
        }
      }
    }
  }
  ul {
    display: flex;
    justify-content: space-between;
    padding: 0.9375rem 0;
    position: relative;
    &:after {
      content: '';
      width: 80%;
      height: 0.1rem;
      position: absolute;
      background-color: #cdcdcd;
      background-color: var(--neutral-color-4);
      /* right: 0; */
      left: 50%;
      transform: translateX(-50%);
      margin: 0 auto;
      z-index: 0;
      top: 2rem;
    }
    li {
      text-align: center;

      color: var(--gray-700);
      z-index: 1;
      // min-width: 25%;
      max-width: 50%;
      flex: 1 1 0;
      width: 0;
      span.bullet {
        content: '';
        top: 0.2rem;
        margin: 0 auto 0.75rem;
        display: block;
        border-radius: 100%;
        height: 1.5625rem;
        width: 1.5625rem;

        background-color: var(--bg-color-primary);
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
        position: relative;

        color: var(--primary);
        line-height: 0.55;
        font-size: 3rem;
        text-align: center;
      }
      span.bullet.bullet--icon {
        height: 2.5rem;
        width: 2.5rem;
        line-height: unset;
        font-size: unset;
        /* display: inline-block; */
        display: flex;
        justify-content: center;
        align-items: center;
      }
      span.name {
        position: relative;
      }
      &.final {
        span.bullet {
          content: '';

          background: var(--primary)
            url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'><path style='fill:rgb(255, 2555, 255)' d='M 0.04038059,0.6267767 0.14644661,0.52071068 0.42928932,0.80355339 0.3232233,0.90961941 z M 0.21715729,0.80355339 0.85355339,0.16715729 0.95961941,0.2732233 0.3232233,0.90961941 z'></path></svg>");

          color: var(--white);
          background-size: 70%;
          background-repeat: no-repeat;
          background-position: center;
        }
      }
      &:last-child:after {
        display: none;
      }
    }
  }

  &.steps--icon {
    ul {
      &:after {
        top: 2.4rem !important;
      }
    }
  }

  ul {
    li {
      span.bullet {
        &.bullet--primary {
          background-color: var(--green);
          i:before {
            color: var(--white);
          }
        }

        &.bullet--secondary {
          background-color: var(--light-blue);
          i:before {
            color: var(--white);
          }
        }

        &.bullet--default {
          background-color: var(--neutral-color-3);
          i:before {
            color: var(--white);
          }
        }
      }
    }
  }

  .list-3 {
    .final:after {
      width: 150%;
    }
  }
  .list-4 {
    .final:after {
      width: 100%;
    }
  }
}
@media (max-width: 48rem) {
  .steps:not(.formtimeline-vertical) {
    ul {
      padding: 0;
      &:after {
        top: 2rem;
      }
      li span.bullet {
        top: 1rem;
      }
    }
    li:not(.active) {
      .step-name {
        display: none;
      }
    }
    li.final {
      top: 2rem;
    }
    li.active {
      .step-name {
        position: absolute;
        left: 0;
        right: 0;
        margin: 0 auto;
        font-weight: $font-bold;

        bottom: -2rem;
      }
    }
  }

  .steps {
    ul {
      li {
        max-width: 100%;
      }
    }
  }
}
</style>
